<ul class="dropdown" [style.left]="left" [style.right]="right" [style.bottom]="bottom">
  <ng-content></ng-content>
</ul>
